'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setNumSoftDeletedMessages = exports.setMessages = exports.setVisitorLastReadAtTimestamp = exports.setEndTimestamp = exports.setStartTimestamp = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setStartTimestamp = exports.setStartTimestamp = (0, _setIn2.default)(_keyPaths.START_TIMESTAMP);

var setEndTimestamp = exports.setEndTimestamp = (0, _setIn2.default)(_keyPaths.END_TIMESTAMP);

var setVisitorLastReadAtTimestamp = exports.setVisitorLastReadAtTimestamp = (0, _setIn2.default)(_keyPaths.VISITOR_LAST_READ_AT_TIMESTAMP);

var setMessages = exports.setMessages = (0, _setIn2.default)(_keyPaths.MESSAGES);

var setNumSoftDeletedMessages = exports.setNumSoftDeletedMessages = (0, _setIn2.default)(_keyPaths.NUM_SOFT_DELETED_MESSAGES);